"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingCell = exports.SidebarInfo = exports.SidebarProfilePic = exports.LoadingSidebar = exports.LoadingContent = exports.ContentText = exports.ContentHeader = exports.LoadingContainer = exports.Container = void 0;
const ui_theme_1 = require("@kyruus/ui-theme");
const styled_1 = __importDefault(require("@emotion/styled"));
const styles_1 = require("../../Shimmer/styles");
exports.Container = (0, styled_1.default)('div') `
  width: 100%;
  height: 100%;
`;
exports.LoadingContainer = (0, styled_1.default)('div') `
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
`;
exports.ContentHeader = (0, styled_1.default)('div') `
  width: 80%;
  height: 2rem;
`;
exports.ContentText = (0, styled_1.default)('div') `
  > div {
    display: flex;
    margin-top: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
    justify-content: space-between;
    > div {
      width: 47%;
      height: 2rem;
    }
  }
`;
exports.LoadingContent = (0, styled_1.default)('div') `
  width: 60%;
`;
exports.LoadingSidebar = (0, styled_1.default)('div') `
  border-radius: 2px;
  border: 1px solid ${(0, ui_theme_1.fromTheme)('color_background_disabled_form_input')};
  padding: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  width: 35%;
  height: 25rem;
`;
exports.SidebarProfilePic = (0, styled_1.default)('div') `
  height: 10rem;
  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_large')};
`;
exports.SidebarInfo = (0, styled_1.default)('div') `
  flex: 1;

  > div {
    width: 100%;
    height: 1.2rem;
    margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_small')};
    &:last-child {
      width: 80%;
      margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_large')};
    }
  }
`;
exports.LoadingCell = (0, styled_1.default)(styles_1.ShimmerBase) ``;
//# sourceMappingURL=styles.js.map